export default {
  outOfStock: {
    id: 'cart_item_unavailable',
    defaultMessage: 'Item no longer available',
  },
  mainTitle: {
    id: 'main_title',
    defaultMessage: 'Your cart',
  },
}
